import React, { useEffect } from 'react';
import { AboutHero } from './about/AboutHero';
import { AboutMission } from './about/AboutMission';
import { AboutCoaches } from './about/AboutCoaches';
import { AboutHiring } from './about/AboutHiring';
import { AboutFinalCTA } from './about/AboutFinalCTA';
export function About() {
  useEffect(() => {
    document.title = 'Meet the Coaches | Storm Taekwondo';
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-446">
      <AboutHero data-id="element-447" />
      <AboutMission data-id="element-448" />
      <AboutCoaches data-id="element-449" />
      <AboutHiring data-id="element-450" />
      <AboutFinalCTA data-id="element-451" />
    </div>;
}